import { Navigate, Outlet, useLocation } from 'react-router-dom';
import {
  nhAppMainPages,
  isRouteAccessible,
} from '@pflegenavi/frontend/routing';
import { useEmployeeIsNursingHomeAdminOrManager } from './roleBasedRestrictions';

export function RouteAccessGuard() {
  const location = useLocation();
  const isAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();

  if (!isRouteAccessible(location.pathname, isAdminOrManager)) {
    return <Navigate to={nhAppMainPages.DASHBOARD} replace />;
  }

  return <Outlet />;
}

export function useCanAccessRoute(path: string): boolean {
  const isAdminOrManager = useEmployeeIsNursingHomeAdminOrManager();
  return isRouteAccessible(path, isAdminOrManager);
}
